import styled from 'styled-components';

export const StyledFormItemContainer = styled.div<{
  labelPosition?: 'top' | 'left';
  justifyContent?: 'space-between' | 'flex-start';
}>`
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: ${({ justifyContent }) => justifyContent || 'space-between'};

  ${({ labelPosition }) =>
    labelPosition === 'top' &&
    `
    flex-direction: column;
    align-items: flex-start;
    // justify-content: flex-start;
    width: 100%;
  `}
`;

export const StyledLabel = styled.label<{ required?: boolean }>`
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: rgba(92, 101, 110, 1);
  margin-bottom: 8px;
  position: relative;
  // flex-shrink: 0;

  ${({ required, theme }) =>
    required &&
    `
    &::after {
      display: inline-block;
      margin-inline-end: 4px;
      color: ${theme.palette.red[500]};
      font-size: 16px;
      font-family: Vinila Variable;
      line-height: 1;
      content: "*";
    }
  `}
`;

export const StyledInputWrapper = styled.div<{
  labelPosition?: 'top' | 'left';
}>`
  position: relative;

  ${({ labelPosition }) =>
    labelPosition === 'top' &&
    `
    width: 100%;
  `}
`;
